import React, { useEffect } from "react";
import ContentBox from "../../components/ContentBox/ContentBox";
import Heading from "../../components/Heading/Heading";
import { events } from "../../data/contents";

function Quiz() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Heading text="Open Quiz" subtext="Vyuhaa'22" />
      <ContentBox
        desc={events.quiz.desc}
        venue={events.quiz.venue}
        time={events.quiz.time}
        contacts={events.quiz.contact}
        rounds={events.quiz.round}
        teamSize={events.quiz.teamSize}
        img_src={events.quiz.img_src}
      />
    </div>
  );
}

export default Quiz;